module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/pets//pet-box_4.png?v=ed458b44";